<template>
    <div>
        <h4 class="title is-4">Статус на испорака</h4>
        <div class="legend mb-4">
            <span class="legend-item" :key="s.key" v-for="s in statuses">
                <span class="tag swatch" :class="{status: s.key} | statusClass"></span>{{s.label}}
            </span>
        </div>
        <Loading v-if="loading"/>
        <p v-else-if="!methods.length" class="has-text-grey">Нема испораки во тек.</p>
        <div v-else class="method mb-4" :key="m.id" v-for="m in methods">
            <div class="is-flex is-justify-content-space-between mb-1">
                <strong>{{m.name}}</strong>
                <span class="progress-label">{{(m.counts.DONE || 0).toLocaleString('mk')}}/{{m.total.toLocaleString('mk')}} - {{percentDone(m)}}%</span>
            </div>
            <div class="bar">
                <span class="tag segment" :key="s.key" v-for="s in statuses" v-show="m.counts[s.key]"
                      :class="{status: s.key} | statusClass"
                      :style="{width: width(m, s.key)}"
                      :title="s.label + ': ' + m.counts[s.key]">
                    {{m.counts[s.key]}}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import Loading from "../Loading";

    export default {
        name: "ShippingMethodsProgress",
        components: {Loading},
        data() {
            return {
                methods: [],
                loading: true,
                statuses: [
                    {key: "DONE", label: "Завршени"},
                    {key: "SHIPPED", label: "Испратени"},
                    {key: "PACKED", label: "Спакувани"},
                    {key: "SUBMITTED", label: "Поднесени"},
                ],
            };
        },
        created() {
            this.$http.get("/stats/shipping-methods-progress")
                .then(a => {
                    this.methods = a.data.data;
                    this.loading = false
                })
        },
        methods: {
            width(m, key) {
                return m.total ? (m.counts[key] / m.total * 100) + "%" : "0";
            },
            percentDone(m) {
                return m.total ? Math.round((m.counts.DONE || 0) / m.total * 100) : 0;
            }
        }
    }
</script>

<style scoped>
    .legend-item {
        margin-right: 1rem;
        white-space: nowrap;
    }

    .swatch {
        width: 12px;
        height: 12px;
        padding: 0;
        border-radius: 2px;
        margin-right: 4px;
        vertical-align: middle;
    }

    .progress-label {
        white-space: nowrap;
        flex-shrink: 0;
        margin-left: 0.5rem;
    }

    .bar {
        display: flex;
        height: 28px;
        border-radius: 4px;
        overflow: hidden;
        background: #ededed;
    }

    .segment {
        height: 28px;
        padding: 0;
        border-radius: 0;
        flex-shrink: 0;
        font-size: 0.8rem;
        font-weight: 600;
        overflow: hidden;
    }
</style>
